(function () {
  function initPreorder(bar) {
    const preorderButton = bar.querySelector('.sticky-atc__button--preorder');
    if (!preorderButton) return;
    const preorderLabel = preorderButton.querySelector('.sticky-atc__preorder-label');
    const formId = preorderButton.dataset.preorderForm;
    const form = document.getElementById(formId);

    const getNativePreorder = () =>
      form ? form.querySelector('[data-native-pre-order-btn]') : null;

    const syncLabel = () => {
      const nativePreorder = getNativePreorder();
      if (nativePreorder && preorderLabel) preorderLabel.textContent = nativePreorder.textContent.trim();
    };

    preorderButton.addEventListener('click', () => {
      const nativePreorder = getNativePreorder();
      if (nativePreorder) nativePreorder.click();
    });

    if (form) {
      new MutationObserver(syncLabel).observe(form, { childList: true, subtree: true, characterData: true });
    }
    syncLabel();
  }

  function initStickyAtc(bar) {
    if (bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';
    document.body.appendChild(bar);

    const mainButton = document.getElementById(bar.dataset.submitId);
    const mainPrice = document.getElementById(bar.dataset.priceId);
    const stickyButton = bar.querySelector('.sticky-atc__button');
    const stickyLabel = bar.querySelector('.sticky-atc__label');
    const stickyPrice = bar.querySelector('.sticky-atc__price');
    const selects = bar.querySelectorAll('.sticky-atc__select');
    let footer = null;

    let passedMain = false;
    let footerVisible = false;
    let clickedFromSticky = false;
    let wasLoading = false;
    let successTimer = null;

    function updateVisibility() {
      const show = passedMain && !footerVisible;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('sticky-atc-active', show);
      document.documentElement.style.setProperty('--sticky-atc-height', bar.offsetHeight + 'px');
    }

    function getTrackedButton() {
      if (!mainButton) return null;
      const wrapper = mainButton.closest('.product-form__buttons');
      const preorder = wrapper
        ? wrapper.querySelector('[data-native-pre-order-btn]:not([data-native-pre-order-btn-added])')
        : null;
      if (preorder && preorder !== mainButton && preorder.offsetParent !== null) return preorder;
      return mainButton;
    }

    function checkMain() {
      const tracked = getTrackedButton();
      if (!tracked) return;
      passedMain = tracked.getBoundingClientRect().bottom < 0;
    }

    function checkFooter() {
      if (!footer) footer = document.querySelector('footer.footer') || document.querySelector('footer');
      if (!footer) return;
      footerVisible = footer.getBoundingClientRect().top < window.innerHeight;
    }

    function onScroll() {
      checkMain();
      checkFooter();
      updateVisibility();
    }

    function mainIsLoading() {
      if (!mainButton) return false;
      const spinner = mainButton.querySelector('.loading-overlay__spinner');
      if (spinner && !spinner.classList.contains('hidden')) return true;
      return mainButton.classList.contains('loading') || mainButton.getAttribute('aria-disabled') === 'true';
    }

    function mainHasError() {
      const wrapper = document.querySelector('#productFormWrapper .product-form__error-message-wrapper');
      return wrapper && !wrapper.hasAttribute('hidden');
    }

    function showSuccess() {
      clearTimeout(successTimer);
      stickyButton.classList.add('is-success');
      successTimer = setTimeout(() => {
        stickyButton.classList.remove('is-success');
        syncFromMain();
      }, 1800);
    }

    function syncFromMain() {
      const loading = mainIsLoading();

      if (mainButton && !stickyButton.classList.contains('is-success')) {
        const mainLabel = mainButton.querySelector('span');
        if (mainLabel) stickyLabel.textContent = mainLabel.textContent.trim();
        stickyButton.disabled = mainButton.disabled;
      }

      stickyButton.classList.toggle('is-loading', loading && clickedFromSticky);

      if (wasLoading && !loading && clickedFromSticky) {
        clickedFromSticky = false;
        if (!mainHasError()) showSuccess();
      }
      wasLoading = loading;

      if (mainPrice) {
        const onSale = mainPrice.querySelector('.price--on-sale');
        const priceEl = onSale
          ? mainPrice.querySelector('.price-item--sale')
          : mainPrice.querySelector('.price-item--regular');
        if (priceEl) stickyPrice.textContent = priceEl.textContent.trim();
      }

      const fieldsets = document.querySelectorAll('variant-radios fieldset');
      selects.forEach((select) => {
        const fieldset = fieldsets[parseInt(select.dataset.optionIndex, 10)];
        if (!fieldset) return;
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) select.value = checked.value;
      });
    }

    stickyButton.addEventListener('click', () => {
      if (stickyButton.disabled) return;
      clickedFromSticky = true;
      stickyButton.classList.remove('is-success');
      stickyButton.classList.add('is-loading');
    });

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        const fieldsets = document.querySelectorAll('variant-radios fieldset');
        const fieldset = fieldsets[parseInt(select.dataset.optionIndex, 10)];
        if (!fieldset) return;
        const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => input.value === select.value);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    if (mainButton) {
      new MutationObserver(syncFromMain).observe(mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    if (mainPrice) {
      new MutationObserver(syncFromMain).observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('change', (event) => {
      if (event.target.closest('variant-radios')) setTimeout(syncFromMain, 300);
    });

    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    setInterval(onScroll, 500);

    initPreorder(bar);
    syncFromMain();
    onScroll();
  }

  function initAll() {
    document.querySelectorAll('.sticky-atc').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();